module.exports = __webpack_public_path__ + "static/media/icon_seguro_automotor.2459ee30.svg";